class EsDrawer extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // Move the drawer to <body> so its fixed positioning escapes any ancestor
    // stacking context (e.g. the sticky #product-configurator on the PDP).
    if (this.parentElement !== document.body) {
      document.body.appendChild(this);
      return;
    }

    const backdrop = document.createElement("es-backdrop");
    this.insertAdjacentElement("afterend", backdrop);

    backdrop.addEventListener("click", () => {
      this.classList.remove("open");
    });
  }
}

customElements.define("es-drawer", EsDrawer);

class EsDrawerHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const closeButton = document.createElement("button");
    closeButton.innerHTML = `
      <span class="inline-block p-3 rounded-full bg-[#F9F7F6] cursor-pointer">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M13.0606 12L19.5303 5.53028C19.8233 5.23731 19.8233 4.7627 19.5303 4.46973C19.2373 4.17676 18.7627 4.17676 18.4697 4.46973L12 10.9395L5.53028 4.46974C5.23731 4.17677 4.7627 4.17677 4.46973 4.46974C4.17676 4.76271 4.17676 5.23732 4.46973 5.53029L10.9395 12L4.46973 18.4697C4.17676 18.7627 4.17676 19.2373 4.46973 19.5303C4.61622 19.6768 4.80812 19.75 5.00001 19.75C5.1919 19.75 5.3838 19.6768 5.53028 19.5303L12 13.0606L18.4697 19.5303C18.6162 19.6768 18.8076 19.75 19 19.75C19.1924 19.75 19.3838 19.6768 19.5303 19.5303C19.8232 19.2373 19.8232 18.7627 19.5303 18.4697L13.0606 12Z" fill="#403833"/>
        </svg>
      </span>
    `;
    this.appendChild(closeButton);

    closeButton.addEventListener("click", () => {
      this.parentElement.classList.remove("open");
    });
  }
}

customElements.define("es-drawer-header", EsDrawerHeader);

class EsButton extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const commandFor = this.getAttribute("commandFor");
    const command = this.getAttribute("command");

    if (commandFor && command) {
      this.addEventListener("click", () => {
        const targetElement = document.getElementById(commandFor);

        if (!targetElement) return;

        if (command === "open") {
          targetElement.classList.add("open");
        }

        if (command === "close") {
          targetElement.classList.remove("open");
        }
      });
    }
  }
}

customElements.define("es-button", EsButton);
